import React from 'react';

import * as ReturnAuthorizationsTable from '../ReturnAuthorizationTable/ReturnAuthorizationTable';
import { QueryReturnAuthorizationsFilterInput } from 'generated/graphql';



export interface IProps {
  storeId?: string;
}

export const FC: React.FC<IProps> = props => {
  const filter = React.useMemo(
    (): QueryReturnAuthorizationsFilterInput => ({
      storeId: props.storeId,
      isReceived: true,
      authorizationApprovalStatus: ['approved'],
      acceptanceApprovalStatus: ['approved'],
      refundApprovalStatus: ['pending']
    }),
    [props.storeId]
  );

  return (
    <ReturnAuthorizationsTable.FC
      filter={filter}
      columnIdsToRender={[
        'approvalDate',
        'orderNumber',
        'orderDate',
        'orderAmount',
        'customerPhoneNumber',
        'netSuiteSalesOrderRecord',
        'shippingStatus'
      ]} />
  );
};
